import styled from 'styled-components'

export const CopyContainer = styled.div`
    position: fixed;
    transition: color .5s ease-in-out;
    font-size: 11px;
    font-family: "sharp_groteskmedium_20",Arial, Helvetica, sans-serif;
    font-weight: 700;    
    color: ${({light,active})=>light&&!active?'black':'white'};
    display: flex;
    align-items:center;
    bottom: 60px;
    left: 60px;
    z-index: 5;
    svg{
        margin-left: 10px;
    }
    @media screen and (max-width: ${({theme})=>theme.breakpoints.tabletSmall}){
        left: 15px;
        bottom: 15px;
    }
`